import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '0'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    buttonItem: {
        marginTop: theme.spacing(2),
    },
    button: {
    },
});

interface IDocumentUploadPhotoUploadMobileSafariProps {
    returnToDocType: () => void;
    viewBasket: () => void;
}

interface IDocumentUploadPhotoUploadMobileSafariState {
}

export class DocumentUploadPhotoUploadMobileSafari extends Component<IDocumentUploadPhotoUploadMobileSafariProps & WithStyles<typeof styles>, IDocumentUploadPhotoUploadMobileSafariState> {
    constructor(props) {
        super(props);

        this.state = {
        }
    }


    public render() {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Secure Document Management
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Alert severity="warning">Photo upload not supported on Safari Mobile</Alert>
                    <Typography>To upload a photo, please log into this site using any modern desktop browser, or any Android browser.</Typography>
                </Grid>
                <Grid container justify="center" alignItems="center" spacing={1}>
                    <Grid item xs={12} sm={6} md={6} className={this.props.classes.buttonItem}>
                        <Button onClick={this.props.returnToDocType} color="primary" variant="contained" className={this.props.classes.button} fullWidth>
                            Upload Another Document
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className={this.props.classes.buttonItem}>
                        <Button onClick={this.props.viewBasket} color="primary" variant="contained" className={this.props.classes.button} fullWidth>
                            View Basket
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(DocumentUploadPhotoUploadMobileSafari);

